export interface Chapter {
  id: number;
  title: string;
  subtitle: string;
  voiceoverPath: string;
  transcriptPath: string;
  musicPath: string;
  fractalType: FractalType;
  colorScheme: ColorScheme;
}

export type FractalType = 
  | 'mandelbrot'
  | 'julia'
  | 'transform'
  | 'elements'
  | 'gradient'
  | 'spiral'
  | 'synthesis';

export interface ColorScheme {
  primary: [number, number, number];
  secondary: [number, number, number];
  accent: [number, number, number];
}

export const chapters: Chapter[] = [
  {
    id: 1,
    title: 'Na krawędzi nieskończoności',
    subtitle: 'Rozdział I',
    voiceoverPath: '/voiceovers/pl/1.mp3',
    transcriptPath: '/voiceovers/pl/1.mp3.json',
    musicPath: '/music/1.mp3',
    fractalType: 'mandelbrot',
    colorScheme: {
      primary: [0.05, 0.08, 0.15],
      secondary: [0.4, 0.25, 0.1],
      accent: [0.85, 0.65, 0.45]
    }
  },
  {
    id: 2,
    title: 'Piąty wymiar',
    subtitle: 'Biblioteka wszystkich wersji',
    voiceoverPath: '/voiceovers/pl/2.mp3',
    transcriptPath: '/voiceovers/pl/2.mp3.json',
    musicPath: '/music/2.mp3',
    fractalType: 'julia',
    colorScheme: {
      primary: [0.08, 0.05, 0.12],
      secondary: [0.2, 0.35, 0.45],
      accent: [0.7, 0.8, 0.9]
    }
  },
  {
    id: 3,
    title: 'Przeskok percepcyjny',
    subtitle: 'Podróż bez ruchu',
    voiceoverPath: '/voiceovers/pl/3.mp3',
    transcriptPath: '/voiceovers/pl/3.mp3.json',
    musicPath: '/music/3.mp3',
    fractalType: 'transform',
    colorScheme: {
      primary: [0.06, 0.06, 0.1],
      secondary: [0.35, 0.25, 0.4],
      accent: [0.75, 0.55, 0.85]
    }
  },
  {
    id: 4,
    title: 'Krawędź',
    subtitle: 'Tam, gdzie żywioły całują się i walczą',
    voiceoverPath: '/voiceovers/pl/4.mp3',
    transcriptPath: '/voiceovers/pl/4.mp3.json',
    musicPath: '/music/4.mp3',
    fractalType: 'elements',
    colorScheme: {
      primary: [0.1, 0.05, 0.05],
      secondary: [0.5, 0.2, 0.1],
      accent: [0.95, 0.5, 0.2]
    }
  },
  {
    id: 5,
    title: 'Poza krawędzią',
    subtitle: 'Wielki gradient',
    voiceoverPath: '/voiceovers/pl/5.mp3',
    transcriptPath: '/voiceovers/pl/5.mp3.json',
    musicPath: '/music/5.mp3',
    fractalType: 'gradient',
    colorScheme: {
      primary: [0.04, 0.04, 0.06],
      secondary: [0.15, 0.15, 0.2],
      accent: [0.5, 0.5, 0.55]
    }
  },
  {
    id: 6,
    title: 'Nawigacja po fraktalu',
    subtitle: 'Sztuka intuicyjnego żeglowania',
    voiceoverPath: '/voiceovers/pl/6.mp3',
    transcriptPath: '/voiceovers/pl/6.mp3.json',
    musicPath: '/music/6.mp3',
    fractalType: 'spiral',
    colorScheme: {
      primary: [0.05, 0.08, 0.1],
      secondary: [0.1, 0.3, 0.35],
      accent: [0.3, 0.7, 0.75]
    }
  },
  {
    id: 7,
    title: 'Jesteś punktem na krawędzi',
    subtitle: 'Synteza',
    voiceoverPath: '/voiceovers/pl/7.mp3',
    transcriptPath: '/voiceovers/pl/7.mp3.json',
    musicPath: '/music/7.mp3',
    fractalType: 'synthesis',
    colorScheme: {
      primary: [0.06, 0.05, 0.08],
      secondary: [0.3, 0.25, 0.35],
      accent: [0.85, 0.75, 0.6]
    }
  }
];

export interface WordData {
  text: string;
  start_time: number;
  end_time: number;
}

export interface SegmentData {
  text: string;
  start_time: number;
  end_time: number;
  words: WordData[];
}

export interface TranscriptData {
  segments: SegmentData[];
}

